import ConditionGradient from './ConditionGradient';
export default ConditionGradient;